import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from '../../Common/Header/Header';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import ChartsContainer from '../../Common/ChartsContainer';

const titleMap = {
    0: 'Tipos de Mortes'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return (
                <ServicesWrapper
                    module={{
                        sectionTitle: 'do Tipos de Mortes'
                    }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.DEATH_TYPE,
                        url: 'governanceroom/dashboard/sihsus/aih/death'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        default:
            return null;
    }
};

export const Discharge = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Mortes',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};